import { useState, useEffect } from 'react';
import { FaServer, FaDatabase, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import { fetchSystemStatus, fetchSystemMetrics } from './api';

const SystemMonitor = () => {
  const [status, setStatus] = useState({
    server: 'healthy',
    database: 'healthy',
    elasticsearch: 'healthy',
    kafka: 'healthy'
  });

  const [metrics, setMetrics] = useState({
    cpu: 0,
    memory: 0,
    disk: 0,
    activeProfiles: 0,
    eventsPerSecond: 0,
    activeRules: 0
  });

  useEffect(() => {
    const loadStatus = async () => {
      const data = await fetchSystemStatus();
      setStatus(data);
    };

    const loadMetrics = async () => {
      const data = await fetchSystemMetrics();
      setMetrics(data);
    };

    loadStatus();
    loadMetrics();

    const interval = setInterval(() => {
      loadStatus();
      loadMetrics();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const renderStatusIcon = (status) => {
    return status === 'healthy' ? (
      <FaCheckCircle className="status-icon healthy" />
    ) : (
      <FaExclamationTriangle className="status-icon warning" />
    );
  };

  return (
    <div className="system-monitor">
      <div className="monitor-header">
        <h1>System Monitor</h1>
      </div>

      <div className="monitor-grid">
        <div className="status-card">
          <h2>System Status</h2>
          <div className="status-items">
            <div className="status-item">
              <FaServer className="service-icon" />
              <div className="status-info">
                <span className="label">Server</span>
                <span className="value">{renderStatusIcon(status.server)} {status.server}</span>
              </div>
            </div>
            <div className="status-item">
              <FaDatabase className="service-icon" />
              <div className="status-info">
                <span className="label">Database</span>
                <span className="value">{renderStatusIcon(status.database)} {status.database}</span>
              </div>
            </div>
            {/* Add other status items */}
          </div>
        </div>

        <div className="metrics-card">
          <h2>System Metrics</h2>
          <div className="metrics-grid">
            <div className="metric-item">
              <span className="label">CPU Usage</span>
              <div className="metric-value">
                <div className="progress-bar" style={{ width: `${metrics.cpu}%` }}>
                  <span>{metrics.cpu}%</span>
                </div>
              </div>
            </div>
            <div className="metric-item">
              <span className="label">Memory Usage</span>
              <div className="metric-value">
                <div className="progress-bar" style={{ width: `${metrics.memory}%` }}>
                  <span>{metrics.memory}%</span>
                </div>
              </div>
            </div>
            {/* Add other metrics */}
          </div>
        </div>

        <div className="stats-card">
          <h2>System Statistics</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="label">Active Profiles</span>
              <span className="value">{metrics.activeProfiles}</span>
            </div>
            <div className="stat-item">
              <span className="label">Events/Second</span>
              <span className="value">{metrics.eventsPerSecond}</span>
            </div>
            <div className="stat-item">
              <span className="label">Active Rules</span>
              <span className="value">{metrics.activeRules}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemMonitor; 